import { render } from "./AddEditRole.vue?vue&type=template&id=2225bd0a"
import script from "./AddEditRole.vue?vue&type=script&lang=js"
export * from "./AddEditRole.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__